export default __webpack_public_path__ + "static/media/avatar_109.733be97f.png";